import { Modal, Text, Group, Button } from "@mantine/core";
import BrandedLoadingOverlay from "./BrandedLoadingOverlay";

function DeleteConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  title = "Delete Confirmation",
  message = "Are you sure you want to delete this item? This action cannot be undone.",
  isLoading = false,
  confirmLabel = "Delete",
  confirmColor = "red",
}) {
  return (
    <Modal opened={isOpen} onClose={onClose} title={title} size="sm">
      <BrandedLoadingOverlay visible={isLoading} />
      <Text mb="lg" style={{ whiteSpace: "pre-line" }}>
        {message}
      </Text>
      <Group w="100%" justify="space-between">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
        <Button color={confirmColor} onClick={onConfirm}>
          {confirmLabel}
        </Button>
      </Group>
    </Modal>
  );
}

export default DeleteConfirmationModal;
